import React, { useEffect, useState } from 'react';
import './Telephony.scss';
import { Button, Drawer, makeStyles } from '@material-ui/core';
import {
  TELEPHONY_DIRECTORY,
  TELEPHONY_EXTENSIONS,
  TELEPHONY_DIRECTORY_CREATE,
  TELEPHONY_DIRECTORY_VIEW,
  TELEPHONY_EXTENSIONS_CREATE,
  TELEPHONY_EXTENSIONS_VIEW,
  TELEPHONY_DIRECTORY_EDIT,
  TELEPHONY_EXTENSIONS_EDIT,
} from '../../../constants/ServiceConstants';
import { useSelector } from 'react-redux';
import { selectedHotelSelector } from '../../property/propertySlice';
import { useHistory } from 'react-router-dom';
import DirecoryList from './directory/directory-list/DirectoryList';
import DirecoryCreate from './directory/directory-create/DirectoryCreate';
import DirecoryView from './directory/directory-view/DirectoryView';
import ExtensionsCreate from './extensions/extensions-create/ExtensionsCreate';
import ExtensionsView from './extensions/extensions-view/ExtensionsView';
import ExtensionsList from './extensions/extensions-list/ExtensionsList';
import { validateUserSession } from '../../../utils/authUtils';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const Telephony = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(TELEPHONY_DIRECTORY);
  const [state, setState] = useState({
    type: TELEPHONY_DIRECTORY,
    status: false,
  });
  const [viewState, setViewState] = useState({
    type: TELEPHONY_DIRECTORY_VIEW,
    status: false,
    obj: null,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const selectedHotel = useSelector(selectedHotelSelector);

  const history = useHistory();

  useEffect(() => {
    validateUserSession(history);
  }, [activeTab, history]);

  useEffect(() => {
    if (activeTab === TELEPHONY_DIRECTORY || activeTab === TELEPHONY_EXTENSIONS) {
      setPage(0);
      setRowsPerPage(5);
    }
  }, [activeTab]);

  useEffect(() => {
    if (selectedHotel && viewState.status) {
      setActiveTab(TELEPHONY_DIRECTORY);
      setViewState({
        type: '',
        status: false,
        obj: null,
      });
    }
  }, [selectedHotel]);

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case TELEPHONY_DIRECTORY_CREATE:
        return (
          <DirecoryCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></DirecoryCreate>
        );
      case TELEPHONY_DIRECTORY_EDIT:
        return (
          <DirecoryCreate
            toggleDrawer={onDrawerToggle}
            directoriesObj={state.obj}
            hotelId={selectedHotel}
            editing={true}
            showLoader={showLoader}
          ></DirecoryCreate>
        );
      case TELEPHONY_EXTENSIONS_CREATE:
        return (
          <ExtensionsCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></ExtensionsCreate>
        );
      case TELEPHONY_EXTENSIONS_EDIT:
        return (
          <ExtensionsCreate
            toggleDrawer={onDrawerToggle}
            extensionObj={state.obj}
            hotelId={selectedHotel}
            editing={true}
            showLoader={showLoader}
          ></ExtensionsCreate>
        );
      default:
        break;
    }
  };

  const onViewToggle = (type, status, obj) => {
    setViewState({ type: type, status: status, obj: obj });
  };

  const onDrawerToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case TELEPHONY_DIRECTORY_VIEW:
        return (
          <DirecoryView
            onViewToggle={onViewToggle}
            onDrawerToggle={onDrawerToggle}
            directoriesObj={viewState.obj}
            permissions={permissions}
          ></DirecoryView>
        );
      case TELEPHONY_EXTENSIONS_VIEW:
        return (
          <ExtensionsView
            onViewToggle={onViewToggle}
            onDrawerToggle={onDrawerToggle}
            obj={viewState.obj}
            permissions={permissions}
          ></ExtensionsView>
        );
      default:
        break;
    }
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  return (
    <>
      <Drawer
        anchor={'right'}
        open={state.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(state)}
      </Drawer>
      {viewState.status && <>{switchViewContent(viewState)}</>}
      {!viewState.status && (
        <div className='container mt-4'>
          <div className='row d-flex'>
            <div className='col col-md-6'>
              <span className='page-title'>Telephony</span>
            </div>
          </div>
          <div className='row d-flex mt-4 accommodation-list'>
            <div className='d-flex flex-wrap'>
              <Button
                size='large'
                variant={activeTab === TELEPHONY_DIRECTORY ? 'outlined' : 'text'}
                className={
                  activeTab === TELEPHONY_DIRECTORY
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(TELEPHONY_DIRECTORY)}
              >
                Directory
              </Button>
              <Button
                size='large'
                variant={activeTab === TELEPHONY_EXTENSIONS ? 'outlined' : 'text'}
                className={
                  activeTab === TELEPHONY_EXTENSIONS
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(TELEPHONY_EXTENSIONS)}
              >
                Extensions
              </Button>
            </div>
          </div>
          <div className='row mx-2 d-flex mt-4'>
            <div className='card shadow'>
              {activeTab === TELEPHONY_DIRECTORY && (
                <DirecoryList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  hotelId={selectedHotel}
                  permissions={permissions}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
              {activeTab === TELEPHONY_EXTENSIONS && (
                <ExtensionsList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  hotelId={selectedHotel}
                  permissions={permissions}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Telephony;
